import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { EmailVerificationControllerService } from '@api-swagger-client/index';

/**
 * Fase 4 — verificación de correo por código de 6 dígitos.
 *
 * Envuelve los endpoints públicos `POST /auth/verify-email-code` y
 * `POST /auth/resend-verification`. Son públicos porque el usuario todavía no tiene
 * sesión: el soft-gate del login lo manda aquí antes de entrar al home.
 */
@Injectable({
    providedIn: 'root',
})
export class EmailVerificationService {
    constructor(private emailVerificationControllerService: EmailVerificationControllerService) {}

    /** Valida el código recibido por correo. */
    verifyCode = (email: string, code: string): Observable<any> => {
        return this.emailVerificationControllerService
            .emailVerificationControllerVerifyEmailCode({ email, code })
            .pipe(catchError((error) => throwError(() => error)));
    };

    /** Reenvía el correo con un código nuevo (y el link como atajo). */
    resend = (email: string): Observable<any> => {
        return this.emailVerificationControllerService
            .emailVerificationControllerResendVerification({ email })
            .pipe(catchError((error) => throwError(() => error)));
    };
}
